// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductCategories_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/product_categories/get/{id}
 *
 * Returns a single product category record. The wire shape of dados is a
 * single ProductCategories_ListaRow object.
 */
import type { ProductCategories_ListaRow } from './ProductCategories_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductCategories_GetResponseDados = ProductCategories_ListaRow;

export type ProductCategories_GetResponse = ApiResponse<ProductCategories_GetResponseDados>;

registerResponseContract('ProductCategories_GetResponse', {
  _nullable:                        { type: 'boolean', required: false },
  so_product_category_id:           { type: 'number',  required: true },
  so_product_category_name:         { type: 'string',  required: true },
  so_product_category_franchise_id: { type: 'number',  required: true },
  so_product_category_active:       { type: 'number',  required: true },
  so_product_category_created_at:   { type: 'string',  required: false },
})
